import styled from 'styled-components';

import BaseRadio from '@r1-frontend/ui-react/components/controls/baseRadio';
import { DescribedCost } from '@r1-frontend/ui-react/components/costs';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IndentContainer, withRadius } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { TPurchaseOptionProps } from './types';

const Purchase = ({
    cost,
    period,
    onSelect,

    ...props
}: TPurchaseOptionProps): JSX.Element => {
    return (
        <IndentContainer $united={[16]} {...props}>
            <BaseRadio
                size='S'
                name={'PurchaseOption'}
                onChange={onSelect(cost, period)}
                data-test='option'
            >
                <DescribedCost installmentPeriod={period} isReverse={true}>{cost}</DescribedCost>
            </BaseRadio>
        </IndentContainer>
    );
};

export default styled(withRadius(Purchase, { $radius: 16 }))`
    background-color: ${COLORS.BgMain};
    cursor: pointer;

    label {
        width: 100%;
        cursor: pointer;
    }

    input[type='radio'] {
        cursor: pointer;
        align-self: center;
    }

    ${DescribedCost} {
        cursor: pointer;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${DescribedCost} {
            width: 100%;
            flex-direction: row-reverse;
            align-items: center;
            justify-content: space-between;
        }
    }
`;
